// extracted by mini-css-extract-plugin
export default {"root":"FileInformationPanelDrawer_root__JYtMu","fileDetailsRoot":"FileInformationPanelDrawer_fileDetailsRoot__i3aMi"};